import PropTypes from 'prop-types';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

import brand from 'utils/designTokens';

// ==============================|| SEARCH FIELD ||============================== //

export default function SearchField({
  value,
  onChange,
  placeholder = 'Search…',
  maxWidth = 480,
  fullWidth = false,
  sx = {}
}) {
  return (
    <TextField
      fullWidth={fullWidth}
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: 'text.secondary', opacity: 0.7 }} />
          </InputAdornment>
        )
      }}
      sx={{
        maxWidth: fullWidth ? 'none' : maxWidth,
        mb: 2,
        '& .MuiOutlinedInput-root': {
          borderRadius: 2.5,
          bgcolor: '#fff',
          transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
          '& fieldset': {
            borderColor: brand.border
          },
          '&:hover fieldset': {
            borderColor: brand.borderHover
          },
          '&.Mui-focused': {
            boxShadow: `0 0 0 3px ${brand.overlay}`,
            '& fieldset': {
              borderColor: 'primary.main'
            }
          }
        },
        ...sx
      }}
    />
  );
}

SearchField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fullWidth: PropTypes.bool,
  sx: PropTypes.object
};
